export const headTableCells = [
  { id: 1, property: '', label: '' },
  { id: 2, property: 'Name', label: 'Name' },
  { id: 3, property: 'WorkPhone', label: 'Phone' },
  { id: 4, property: 'WorkEmail', label: 'Email' },
  { id: 5, property: 'TypeTitle', label: 'Type' },
];
